export const WorkOrderItemSource = {
  QUOTATION: "QUOTATION",
  ADHOC: "ADHOC",
} as const;

export type WorkOrderItemSourceValue =
  (typeof WorkOrderItemSource)[keyof typeof WorkOrderItemSource];

export const WorkOrderItemType = {
  MATERIAL: "MATERIAL",
  LABOR: "LABOR",
  SERVICE: "SERVICE",
} as const;

export type WorkOrderItemTypeValue =
  (typeof WorkOrderItemType)[keyof typeof WorkOrderItemType];

export const WorkOrderItemTypeLabelMap: Record<WorkOrderItemTypeValue, string> =
  {
    [WorkOrderItemType.MATERIAL]: "Material",
    [WorkOrderItemType.LABOR]: "Labour",
    [WorkOrderItemType.SERVICE]: "Service",
  };

export const WorkOrderItemStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
} as const;

export type WorkOrderItemStatusValue =
  (typeof WorkOrderItemStatus)[keyof typeof WorkOrderItemStatus];
